import { render } from "./AppButtonDeny.vue?vue&type=template&id=d0425d5c&scoped=true"
import script from "./AppButtonDeny.vue?vue&type=script&lang=js"
export * from "./AppButtonDeny.vue?vue&type=script&lang=js"

import "./AppButtonDeny.vue?vue&type=style&index=0&id=d0425d5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0425d5c"

export default script